<img src="../../../../assets/images/sidebar-logo.png" alt="" />

<div class="servey-center step-2">
  <h4>How do you feel about the pace of the class?</h4>
  <ul class="review-item-wrapper">
    <li class="review-item" *ngFor="let item of InputArray">
      <input
        type="radio"
        (change)="radioChange(item)"
        name="FeelAboutClassButton"
        [checked]="item.checked"
      />
      <label
        ><span>{{ item.Name }}</span></label
      >
    </li>
  </ul>
</div>
<div class="form-button-next">
  <button type="button" class="frm-prev-btn">
    <span class="material-icons" (click)="back()">arrow_back</span>
  </button>
  <button
    type=" button"
    class="frm-next-btn"
    (click)="UpdateFeelAboutValue()"
    [disabled]="checkValidation()"
  >
    <span class="material-icons"> arrow_forward </span>
  </button>
</div>
<ngx-spinner
  bdColor="#00041aa6"
  size="default"
  color="##d7779b"
  template="<img src='../../../assets/images/loading.gif' class='loading-indicator'/>"
  [fullScreen]="true"
>
</ngx-spinner>
